import type { DialogOptions } from '@morpho-org/ui-v6/client'

export const POSITION_MANAGER_DIALOG_OPTIONS = {
  padding: 'p-md md:p-lg'
} satisfies DialogOptions

/** Width the position-manager dialogs use on desktop. */
export const DIALOG_MAX_WIDTH = '540px'
